"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lexemes = require('./config/lexemes');
const helpers = require('./helpers/lexer');
function strToLexemes(str, spaces) {
    let lexemesArray = [];
    str = helpers.clearSpaces(str, spaces);
    while (str.length > 0) {
        let escaped = false;
        if (str.charAt(0) === '\\') {
            escaped = true;
            str = str.slice(1);
            if (str.length === 0) {
                throw new Error('Backslash at end of string');
            }
        }
        let ret = Object.keys(lexemes).some(function (name) {
            if (escaped && lexemes[name].escaped) {
                return false;
            }
            let regexp = helpers.generateRegexp(lexemes[name]);
            if (regexp.test(str)) {
                str = lexemes[name].lexer(str, lexemesArray, spaces);
                return true;
            }
            return false;
        });
        if (!ret) {
            throw new Error('Unknown character : ' + str.charAt(0));
        }
        str = helpers.clearSpaces(str, spaces);
    }
    return lexemesArray;
}
exports.strToLexemes = strToLexemes;
